import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from 'Components';
import CallSplitIcon from '@material-ui/icons/CallSplit';
import './SplitReportButton.css';

const SplitReportButton = ({ onButtonClick, title, subTitle }) => (
  <div>
    <Button onClick={onButtonClick} className="actions__SplitReportButton">
      <div className="actions__SplitReportButton__text">
        <div>{title}</div>
        <div>{subTitle}</div>
      </div>
      <CallSplitIcon
        style={{ color: 'red', rotate: '90deg', fontSize: '30px' }}
      />
    </Button>
  </div>
);

SplitReportButton.propTypes = {
  onButtonClick: PropTypes.func,
  title: PropTypes.string,
  subTitle: PropTypes.string,
};
export default SplitReportButton;



// WEBPACK FOOTER //
// ./src/components/Actions/SplitReport/SplitReport_Button/SplitReportButton.jsx